import {Environment} from '@coolcolduk/enum';
import {env} from './getEnvVar';

export function isDev() {
  return env.mode === Environment.DEV;
}

export function isStaging() {
  return env.mode === Environment.STAGE;
}

export function isProd() {
  return env.mode === Environment.PROD;
}
